import {getAccountsWebUrl} from "../../env/env";
import {IntegrationApp} from "./app-names";

export const useMicrosoftAuthUri = (originURI: string, prompt: string) => {
  return {
    oneDriveAuthUri: createOneDriveAuthUri(originURI, prompt),
  }
};

function createOneDriveAuthUri(openerURI: string, prompt: string) {
  const props: authProps = {
    client_id: "4c3341e0-a1ef-4e0c-b5b1-70088c25c8b3",
    scope: "OneDrive.ReadWrite",
    redirect_uri: getAccountsWebUrl(`/integrations/${IntegrationApp.OneDrive}/post-auth`),
    response_type: "token",
    response_mode: "fragment",
    prompt,
    state: openerURI,
  }
  return createMicrosoftAuthUri(props);
}

type authProps = {
  [id: string]: string;
}

function createMicrosoftAuthUri(props: authProps) {
  // https://learn.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow#request-an-authorization-code
  // https://learn.microsoft.com/en-us/onedrive/developer/rest-api/getting-started/graph-oauth?view=odsp-graph-online#token-flow
  const u = new URL("https://login.microsoftonline.com/common/oauth2/v2.0/authorize");
  for (const k in props) {
    u.searchParams.set(k, props[k]);
  }
  return u;
}

